import { EnumMotivoCancelamento } from "model/enums/enum-motivo-cancelamento";
import { guidEmpty } from "utils/guid-empty";

export class ContratoCancelamentoModel {
  constructor(
    public id: string = guidEmpty(),
    public motivoCancelamento: string = '',
    public indCancelamento: EnumMotivoCancelamento | undefined = undefined,
  ) { }
}